var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 99,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.648 68.864l-4.608-4.608L34.056 86.24V.32h-6.528v85.92L5.544 64.256.936 68.864 30.792 98.72l29.856-29.856z",
    fill: "#000"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjEiIGhlaWdodD0iOTkiIHZpZXdCb3g9IjAgMCA2MSA5OSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTYwLjY0OCA2OC44NjRMNTYuMDQgNjQuMjU2TDM0LjA1NiA4Ni4yNEwzNC4wNTYgMC4zMTk5OTZMMjcuNTI4IDAuMzE5OTk1TDI3LjUyOCA4Ni4yNEw1LjU0NCA2NC4yNTZMMC45MzU5OTcgNjguODY0TDMwLjc5MiA5OC43Mkw2MC42NDggNjguODY0WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==";
export { SvgArrow as ReactComponent };